import { getApi } from '../api/storeFront';
import { parseOrder } from '../utils';
const getOrderById = async ({ count, cursor, id }, logger) => {
    const urlParams = new URLSearchParams();
    urlParams.append('count', count.toString());
    urlParams.append('cursor', cursor.toString());
    // API does not provide media so for now adding dummy media URL.
    const media = [
        {
            url: 'https://cdn.shopify.com/s/files/1/0742/9911/3793/files/Photobook2.jpg?v=1689140166',
        },
        {
            url: 'https://cdn.shopify.com/s/files/1/0742/9911/3793/files/Phonecase1.jpg?v=1688102972',
        },
        {
            url: 'https://cdn.shopify.com/s/files/1/0742/9911/3793/files/Photobook2_55271e2b-5ecf-4581-9419-575b99a75dcb.jpg?v=1688100069',
        },
    ];
    const resp = await getApi(`/order/${id}?${urlParams.toString()}`, logger);
    let parsedData = [];
    if (resp?.size && resp.size > 0) {
        parsedData = parseOrder(resp.data);
        parsedData.map((_, index) => {
            parsedData[index].media = media;
        });
    }
    return { data: [...parsedData] };
};
export default getOrderById;
